import { combineReducers } from 'redux';
import { merge } from 'lodash'
import { normalize, schema } from 'normalizr';

// Define a vtParamMaps schema
const vtParamMapSchema = new schema.Entity('vtParamMaps', {}, { idAttribute: 'ID' });
const vtParamMapListSchema = [vtParamMapSchema];

const defaultVtParamMapParams = {
  vtParamMapFetched: false,
  searchFetched: false,
  isDelFetched: false,
  createTitle: 'Create New VtParamMap',
  createSubmitButtonText: 'Create VtParamMap',
  editTitle: 'Edit VtParamMap',
  editSubmitButtonText: 'Update'
}


function byId(state = {}, action) {
  if (action.type === 'SAVED_VTPARAMMAP') {
    const vtParamMapID = action.payload.ID;
    return {
      ...state,
      [vtParamMapID]: action.payload
    }
  }
  if (action.type === 'FETCHED_VTPARAMMAP') {
    const normalizedVtParamMap = normalize(action.payload, vtParamMapListSchema);
    return merge({}, state, normalizedVtParamMap.entities.vtParamMaps)
  }
  if (action.type === 'DELETED_VTPARAMMAP') {
    if (action.payload.msg === "Success") {
      const vtParamMapID = action.payload.ID;
      return {
        ...state,
        [vtParamMapID]: {
          ...state[vtParamMapID],
          status: 0
        }
      }
    } else {
      return state
    }
  }
  if (action.type === 'RESET_DATA') {
    return {}
  } else {
    return state
  }
}

function searchResults(state = {}, action) {
  if (action.type === 'STORE_SEARCH_VTPARAMMAP_RESULT') {
    const normalizedVtParamMap = normalize(action.payload, vtParamMapListSchema);
    return merge({}, normalizedVtParamMap.entities.vtParamMaps)
  } else {
    return state
  }
}

function filterResults(state = {}, action) {
  if (action.type === 'FILTER_ITEMS') {
    const col = action.payload.col;
    return {
      ...state,
      [col]: action.payload
    }
  } else {
    return state
  }
}

function notifications(state = {}, action) {
  if (action.type === 'SAVED_VTPARAMMAP') {
    return {
      ...state,
      [action.payload.ID]: {
        ...state[action.payload.ID],
        save: {
          status: (action.txn === "success" || action.txn === "Success") ? 'success' : 'error',
          msg: action.msg || action.txn
        }
      }
    }
  }
  if (action.type === 'DELETED_VTPARAMMAP') {
    return {
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        delete: {
          status: action.payload.msg === "Success" ? 'success' : 'error',
          msg: action.payload.msg
        }
      }
    }
  }
  if (action.type === 'NOTIFICATION_DONE_VTPARAMMAP') {
    const { id, type } = action.payload
    // Remove the 'id' element from state
    const { [id]: idValue, ...restOfState } = state;
    // Remove the 'type' from the 'id' element
    const { [type]: removedValue, ...restOfId } = idValue;
    // Merge back together
    const finalState = { ...restOfState, [id]: restOfId };
    return finalState

  } else {
    return state
  }
}


function params(state = defaultVtParamMapParams, action) {
  if (action.type === 'FETCHED_VTPARAMMAP') {
    return {
      ...state,
      vtParamMapFetched: true,
      isFetching: false
    }
  }
  if (action.type === 'FETCH_VTPARAMMAP') {
    return {
      ...state,
      vtParamMapFetched: false,
      isFetching: true
    }
  }
  if (action.type === 'SEARCH_VTPARAMMAP') {
    return {
      ...state,
      searchFetched: false,
      isSearching: true,
    }
  }
  if (action.type === 'STORE_SEARCH_VTPARAMMAP_RESULT') {
    return {
      ...state,
      searchFetched: true,
      isSearching: false,
    }
  }
  if (action.type === 'DELETED_VTPARAMMAP') {
    return {
      ...state,
      isDelFetched: true
    }
  } if (action.type === 'SET_VTPARAMMAP_FETCH_OFF') {
    return {
      ...state,
      isDelFetched: false
    }
  }
  if (action.type === 'RESET_DATA') {
    return defaultVtParamMapParams
  } else {
    return state
  }
}

function dataSetOnOpenEdit(state = {}, action) {
  if (action.type === 'SET_ROW_INDEX_VTPARAMMAP') {
    return action.payload;
  } else {
    return state
  }
}


const vtparammap = combineReducers({
  byId,
  notifications,
  searchResults,
  params,
  filterResults,
  dataSetOnOpenEdit
});

export default vtparammap;

